import { Injectable } from "@angular/core";

export interface BadgeItem {
    type: string;
    value: string;
}

export interface ChildrenItems {
    state: string;
    target?: boolean;
    name: string;
    type?: string;
    children?: ChildrenItems[];
}

export interface MainMenuItems {
    state: string;
    short_label?: string;
    main_state?: string;
    target?: boolean;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    children?: ChildrenItems[];
    level: any;
    system?: any;
}

export interface Menu {
    label: string;
    levels: any;
    main: MainMenuItems[];
}

const MENUITEMS = [
    {
        label: "Navegación",
        levels: [0],
        main: [
            {
                state: "dashboard",
                short_label: "D",
                name: "Dashboard",
                type: "link",
                icon: "icon-layout-cta-right",
                level: [0],
                sublevel: 0,
            },
        ],
    },
    {
        label: "General",
        levels: [0],
        main: [
            {
                main_state: "general",
                state: "busqueda",
                short_label: "BUS",
                name: "Busqueda",
                type: "sub",
                icon: "fa fa-search",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "producto",
                        name: "Buscar productos",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
            {
                main_state: "general",
                state: "reporte",
                short_label: "BUS",
                name: "Reporte",
                type: "sub",
                icon: "fa fa-chart-pie",
                level: [4],
                sublevel: 0,
                children: [
                    {
                        state: "venta",
                        name: "Ventas",
                        type: "sub",
                        level: [0],
                        sublevel: 0,
                        children: [
                            {
                                state: "venta",
                                name: "Reporte de ventas",
                                level: [0],
                                sublevel: 0,
                            },
                        ],
                    },
                    {
                        state: "contabilidad",
                        name: "Contabilidad",
                        type: "sub",
                        level: [0],
                        sublevel: 0,
                        children: [
                            {
                                state: "estado-cuenta",
                                name: "Estados de cuenta",
                                level: [0],
                                sublevel: 0,
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        label: "Compra",
        levels: [2, 3, 5],
        main: [
            {
                main_state: "compra",
                state: "compra",
                short_label: "CR",
                name: "Compras",
                type: "sub",
                icon: "fa fa-shopping-bag",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "registrar",
                        name: "Registrar compra",
                        level: [3],
                        sublevel: 0,
                    },
                    {
                        state: "autorizar",
                        name: "Autorizar compra",
                        level: [3],
                        sublevel: 0,
                    },
                    {
                        state: "recepcionar",
                        name: "Recepcionar compra",
                        level: [5],
                        sublevel: 2,
                    },
                    {
                        state: "historial",
                        name: "Historial",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
        ],
    },
    {
        label: "Pre Venta",
        levels: [2, 4],
        main: [
            {
                main_state: "pre-venta",
                state: "oportunidad",
                short_label: "OP",
                name: "Oportunidades",
                type: "sub",
                icon: "fa fa-folder",
                level: [4],
                sublevel: 0,
                children: [
                    {
                        state: "registrar",
                        name: "Registrar oportunidad",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "historial",
                        name: "Historial",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
            {
                main_state: "pre-venta",
                state: "cotizacion",
                short_label: "OP",
                name: "Cotizaciones",
                type: "sub",
                icon: "fa fa-dollar-sign",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "registrar",
                        name: "Registrar cotización",
                        level: [4],
                        sublevel: 0,
                    },
                    {
                        state: "historial",
                        name: "Historial",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
        ],
    },
    {
        label: "Venta",
        levels: [4],
        main: [
            {
                main_state: "venta",
                state: "venta",
                short_label: "VTA",
                name: "Ventas",
                type: "sub",
                icon: "fa fa-shopping-bag",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "registrar",
                        name: "Registrar venta",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "pendiente",
                        name: "Pendientes",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "problema",
                        name: "En problemas",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "cancelar",
                        name: "Cancelar",
                        level: [0],
                        sublevel: 1,
                    },
                ],
            },
            {
                main_state: "venta",
                state: "marketplace",
                short_label: "PL",
                name: "Marketplaces",
                type: "sub",
                icon: "fa fa-archive",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "publicacion",
                        name: "Publicaciones",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
        ],
    },
    {
        label: "Almacén",
        levels: [5],
        main: [
            {
                main_state: "almacen",
                state: "packing",
                short_label: "PACK",
                name: "Packing",
                type: "link",
                icon: "fa fa-cube",
                level: [5],
                sublevel: 2,
            },
            {
                main_state: "almacen",
                state: "producto",
                short_label: "PRO",
                name: "Productos",
                type: "link",
                icon: "fa fa-dolly",
                level: [5],
                sublevel: 1,
            },
            {
                main_state: "almacen",
                state: "movimiento",
                short_label: "FA",
                name: "Movimientos",
                type: "sub",
                icon: "fa fa-exchange",
                level: [5],
                sublevel: 3,
                children: [
                    {
                        state: "crear",
                        name: "Crear movimiento",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "historial",
                        name: "Historial",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
        ],
    },
    {
        label: "Contabilidad",
        levels: [2],
        main: [
            {
                main_state: "contabilidad",
                state: "pago",
                short_label: "FA",
                name: "Pagos",
                type: "link",
                icon: "fa fa-file-invoice-dollar",
                level: [0],
                sublevel: 0,
            },
            {
                main_state: "contabilidad",
                state: "factura",
                short_label: "FA",
                name: "Facturas",
                type: "sub",
                icon: "fa fa-file-invoice",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "pendiente",
                        name: "Pendientes",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
        ],
    },
    {
        label: "Entidades",
        levels: [1, 2, 4],
        main: [
            {
                main_state: "entidad",
                state: "empresa",
                short_label: "EM",
                name: "Empresas",
                type: "sub",
                icon: "fa fa-building",
                level: [1],
                sublevel: 0,
                children: [
                    {
                        state: "registrar",
                        name: "Registar empresa",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "historial",
                        name: "Empresas",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
            {
                main_state: "entidad",
                state: "cliente",
                short_label: "CL",
                name: "Clientes",
                type: "link",
                icon: "fa fa-users",
                level: [2, 4],
                sublevel: 0,
            },
            {
                main_state: "entidad",
                state: "proveedor",
                short_label: "CL",
                name: "Provedores",
                type: "link",
                icon: "fa fa-users",
                level: [2, 5],
                sublevel: 0,
            },
        ],
    },
    {
        label: "Sistema",
        levels: [1],
        main: [
            {
                main_state: "sistema",
                state: "area",
                short_label: "AR",
                name: "Áreas",
                type: "link",
                icon: "fa fa-square",
                level: [0],
                sublevel: 0,
            },
            {
                main_state: "sistema",
                state: "almacen",
                short_label: "ALM",
                name: "Almacenes",
                type: "link",
                icon: "fa fa-map-pin",
                level: [0],
                sublevel: 0,
            },
            {
                main_state: "sistema",
                state: "marketplace",
                short_label: "MA",
                name: "Marketplaces",
                type: "sub",
                icon: "fa fa-laptop",
                level: [0],
                sublevel: 0,
                children: [
                    {
                        state: "registrar",
                        name: "Registrar marketplace",
                        level: [0],
                        sublevel: 0,
                    },
                    {
                        state: "marketplace-area",
                        name: "Marketplace / Área",
                        level: [0],
                        sublevel: 0,
                    },
                ],
            },
            {
                main_state: "sistema",
                state: "usuario",
                short_label: "US",
                name: "Usuarios",
                type: "link",
                icon: "fa fa-users-cog",
                level: [0],
                sublevel: 0,
            },
        ],
    },
];

@Injectable()
export class MenuItems {
    getAll(): Menu[] {
        return MENUITEMS;
    }
}
